import { useContext, useEffect, useState } from 'react';
import { SelectedStylepackContext } from './stylepack-context';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import { stylePackBannerImages } from './stylepack-resources';
// TODO pull in when can pull from greenroom's api
// import LoadStylepackThemes from '@/connection/greenroom/load-stylepack-themes';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import classNames from 'classnames';
import styles from './stylepacks.module.css';
import { Link } from 'react-router-dom';
import Chip from '@styles/design-system/components/chips/chip';
import { stylepackContentTypeMap, type ContentTemplate, VideoType } from '@/types/stylepacks.types';
import OptionalComponent from '@ui/optional-component/optional-component';

// greenroom images need this replacement to work
// https://greenroom-static-assets.greenroom-dev.brandlive.cloud/title_templates/stock_images/ (default image filename)

export default function StylepackHeader() {
  const stylepack = useContext(SelectedStylepackContext).stylepack;
  const [availableTypes, setAvailableTypes] = useState<VideoType[]>(Object.values(VideoType));

  // TODO pull in colors from theme when greenroom api endpoint exists
  // useEffect(() => {
  //   if (stylepack) {
  //     LoadStylepackThemes({ channel: 0, stylepack: 'all' }).then(console.log).catch(console.error);
  //   }
  // }, [stylepack]);

  useEffect(() => {
    if (stylepack?.videos) {
      const availableTypes = stylepack.videos
        .map((video: ContentTemplate) => (video.contentType ? stylepackContentTypeMap[video.contentType] : undefined))
        .filter((type) => !!type);

      setAvailableTypes([VideoType.all, ...Array.from(new Set(availableTypes))]);
    } else {
      setAvailableTypes(Object.values(VideoType));
    }
  }, [stylepack?.videos]);

  return (
    <Container
      backgroundImage={stylePackBannerImages[stylepack.stylePack]}
      width="100%"
      className={classNames('flex flex-column', styles.header)}
      padding="40px"
      borderRadius="12px"
      gap="16px"
      hoverBackground="transparent"
      transitionDuration="0ms"
    >
      <Container className="flex ai-center jc-space-between" hoverBackground="transparent">
        <Text tag="h2" className="H2">
          {stylepack.name}
        </Text>
        <Link to="./browse" relative="path">
          <Button designSize="large" design="LocalBttnSecHalfTransp" className="flex gap-8 ai-center">
            <Icon name={ICONS.REDO_ALT} size={12} />
            <Text className="L1">Switch Stylepack</Text>
          </Button>
        </Link>
      </Container>
      <Container height="48px">{/* Theme colors cannot be loaded due to greenroom api bug - TODO */}</Container>
      <Container className="flex gap-8">
        <OptionalComponent display={availableTypes.includes(VideoType.countowns)}>
          <Chip type="filter-tab" label="Countdowns" icon={ICONS.COUNTDOWNS} size={32} />
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.bookends)}>
          <Chip type="filter-tab" label="Bookends" icon={ICONS.BOOKENDS} size={32} />
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.walkups)}>
          <Chip type="filter-tab" label="Walkups" icon={ICONS.WALKUPS} size={32} />
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.lowers)}>
          <Chip type="filter-tab" label="Lowers" icon={ICONS.LOWERS} size={32} />
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.segments)}>
          <Chip type="filter-tab" label="Segments" icon={ICONS.SEGMENTS} size={32} />
        </OptionalComponent>
      </Container>
    </Container>
  );
}
